import React from 'react';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AlarmIcon from '@mui/icons-material/Alarm';
import AlertIcon from '@mui/icons-material/Announcement';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadingIcon from '@mui/icons-material/Downloading';
import EditIcon from '@mui/icons-material/Edit';
import EditOffIcon from '@mui/icons-material/EditOff';
import FactoryIcon from '@mui/icons-material/Factory';
import FeedIcon from '@mui/icons-material/Feed';
import GroupsIcon from '@mui/icons-material/Groups';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import HomeIcon from '@mui/icons-material/Home';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import PublishIcon from '@mui/icons-material/Publish';
import ReadIcon from '@mui/icons-material/AutoStories';
import SafetyDividerIcon from '@mui/icons-material/SafetyDivider';
import SendIcon from '@mui/icons-material/Send';
import SettingsIcon from '@mui/icons-material/Settings';
import SmsIcon from '@mui/icons-material/Sms';
import TaskIcon from '@mui/icons-material/Task';
import TrainingIcon from '@mui/icons-material/DesignServices';
import UpdateIcon from '@mui/icons-material/Update';
import UploadIcon from '@mui/icons-material/DriveFolderUpload';
import UpdateFileIcon from '@mui/icons-material/DescriptionOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';

export {
  AutoStoriesIcon,
  AlarmIcon,
  AlertIcon,
  AccessTimeIcon,
  AccountCircleIcon,
  AddCircleOutlineIcon,
  CheckCircleOutlineIcon,
  CloudUploadIcon,
  DownloadingIcon,
  EditIcon,
  EditOffIcon,
  FeedIcon,
  FactoryIcon,
  GroupsIcon,
  HighlightOffIcon,
  HolidayVillageIcon,
  HomeIcon,
  HomeWorkIcon,
  HowToRegIcon,
  LoginIcon,
  LogoutIcon,
  MenuIcon,
  PendingActionsIcon,
  PublishIcon,
  ReadIcon,
  SafetyDividerIcon,
  SendIcon,
  SmsIcon,
  SettingsIcon,
  TaskIcon,
  TrainingIcon,
  UpdateIcon,
  UploadIcon,
  UpdateFileIcon,
  VerifiedIcon,
};

const GetIconByType = (iconType) => {
  switch (iconType) {
    case 'alarm':
      return <AlarmIcon color="primary" />;
    case 'alert':
      return <AlertIcon color="primary" />;
    case 'accessTime':
      return <AccessTimeIcon color="primary" />;
    case 'accountCircle':
      return <CheckCircleOutlineIcon color="primary" />;
    case 'addCircle':
      return <AddCircleOutlineIcon color="primary" />;
    case 'cloudUpload':
      return <CloudUploadIcon color="primary" />;
    case 'downloading':
      return <DownloadingIcon color="primary" />;
    case 'editIcon':
      return <EditIcon color="primary" />;
    case 'editOff':
      return <EditOffIcon color="primary" />;
    case 'factory':
      return <FactoryIcon color="primary" />;
    case 'feed':
      return <FeedIcon color="primary" />;
    case 'groups':
      return <GroupsIcon color="primary" />;
    case 'highlightOff':
      return <HighlightOffIcon color="primary" />;
    case 'holidayVillage':
      return <HolidayVillageIcon color="primary" />;
    case 'home':
      return <HomeIcon color="primary" />;
    case 'homeWork':
      return <HomeWorkIcon color="primary" />;
    case 'howToReg':
      return <HowToRegIcon color="primary" />;
    case 'login':
      return <LoginIcon color="primary" />;
    case 'logout':
      return <LogoutIcon color="primary" />;
    case 'menu':
      return <MenuIcon color="primary" />;
    case 'pending':
      return <PendingActionsIcon color="primary" />;
    case 'publish':
      return <PublishIcon color="primary" />;
    case 'read':
      return <ReadIcon color="primary" />;
    case 'dividerIcon':
      return <SafetyDividerIcon color="primary" />;
    case 'send':
      return <SendIcon color="primary" />;
    case 'settings':
      return <SettingsIcon color="primary" />;
    case 'sms':
      return <SmsIcon color="primary" />;
    case 'training':
      return <TrainingIcon color="primary" />;
    case 'upload':
      return <UploadIcon color="primary" />;
    case 'updateFileIcon':
      return <UpdateFileIcon color="primary" />;
    case 'verified':
      return <VerifiedIcon color="primary" />;
    default:
      // Ícone padrão, se o tipo não for correspondido
      return null;
  }
};

export { GetIconByType };
